export const round = (value: number) => {
    return Math.round((value + Number.EPSILON) * 100) / 100

    // return Number.parseFloat(value.toFixed(2));
}

export default round
